import { SlideFrame } from '../SlideFrame';
import { PlanetDots } from '../PlanetDots';

export function Slide05UniverseExpansion({ universe }: { universe: number }) {
  return (
    <SlideFrame pageNum={8} title="THE VISUALIZER  —  UNIVERSE EXPANSION"
      banner="The discipline was always ours. AI gives us the reach to apply it everywhere.">
      <div className="h-full flex flex-col items-center justify-center gap-8 px-6" style={{ transform: 'scale(0.93)', transformOrigin: 'center center' }}>
        <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-6 w-full">
          <div className="flex flex-col items-center gap-3">
            <div className="relative flex items-center justify-center">
              <PlanetDots count={125} color="#e2e8f0" scale={5.5} hubRadius={48} />
              <div className="absolute text-[56px] font-bold text-white tabular-nums leading-none">125</div>
            </div>
            <div className="text-[14px] tracking-[0.25em] uppercase text-white/80 text-center mt-1">
              Traditional
            </div>
            <p className="text-[15px] text-white/65 text-center max-w-xs leading-snug">
              Number of companies we could realistically follow prior to the Visualizer.
            </p>
          </div>

          <div className="text-[#c9a84c] text-[64px] font-light leading-none px-2">→</div>

          <div className="flex flex-col items-center gap-3">
            <div className="relative flex items-center justify-center">
              <PlanetDots count={universe} color="#c9a84c" scale={2.8} hubRadius={68} dotRadius={2} />
              <div className="absolute text-[80px] font-bold text-[#c9a84c] tabular-nums leading-none">{universe}</div>
            </div>
            <div className="text-[14px] tracking-[0.25em] uppercase text-[#c9a84c]/95 text-center mt-1">
              With AI
            </div>
            <p className="text-[15px] text-white/75 text-center max-w-xs leading-snug">
              Companies we now follow with the Visualizer, across the US, Canada, Hong Kong, and Europe. Expansion into additional global markets is planned.
            </p>
          </div>
        </div>
      </div>
    </SlideFrame>
  );
}
